import styled from "styled-components";

export const ClientDocumentsTableRowColumn = styled.td`
    width: ${({ width }) => width ?? "auto"};
    max-width: 0 !important;
    padding: 0.6rem !important;
    vertical-align: middle;
`;